import React from "react"

/**
 * Splits title at '+' and wraps the part after '+' in a span for smaller text
 * @param {string} title - The title string to process
 * @returns {React.Element} - JSX with the part after '+' wrapped in a span
 */
export const formatTitleWithSmallSuffix = (title) => {
  if (!title || typeof title !== "string") return title

  const plusIndex = title.indexOf("+")

  // If no '+' found, return the title as is
  if (plusIndex === -1) return title

  const beforePlus = title.substring(0, plusIndex + 1) // Include the '+'
  const afterPlus = title.substring(plusIndex + 1)

  return (
    <>
      {beforePlus}
      <span className="text-small">{afterPlus}</span>
    </>
  )
}
